<template>
  <div class="top-block">
    <div class="left">
      <img class="avatar" :src="tr.avatar" alt="trainer-avatar" />
      <LikesBlock :rating="tr.rating" />
    </div>

    <div class="right">
      <div class="name">
        <p>{{ tr.first_name }}</p>
        <p>{{ tr.last_name }}</p>
      </div>
      <SocialLinksComponent :links="tr.social_networks" />
      <LikesBlock :rating="tr.rating" />
      <p class="tr-id">{{ $t('common.trainer') }} ID: {{ id }}</p>
      <div v-if="isNativeDomain" class="bottom-block">
        <div class="phones">
          <a :href="`tel:${phones.FIRST}`">
            <i class="icon-phone" />
            {{ phones.FIRST }}
          </a>
          <a :href="`tel:${phones.SECOND}`">
            <i class="icon-phone" />
            {{ phones.SECOND }}
          </a>
        </div>
        <MessageButton
          :trainer-name="trFullname"
          class="write-btn"
          :trainer-id="id"
          :icon-email="false"
        />
      </div>
      <div v-else class="bottom-block">
        <div class="contacts hidden">
          <div v-if="contacts.phones.length" class="tel">
            <a
              v-for="(tel, idx) in contacts.phones"
              :key="idx"
              :href="`tel:${tel}`"
            >
              <i class="icon-phone" />
              {{ tel }}
            </a>
          </div>
          <div class="mail-site">
            <a
              v-for="(mail, idx) in contacts.emails"
              :key="idx"
              :href="`mailto:${mail}`"
            >
              <i class="icon-email mr-1" />
              {{ mail }}
            </a>
            <a v-if="contacts.site" :href="contacts.site" target="_blank">
              <i class="icon-website mr-1" />
              {{ contacts.site }}
            </a>
          </div>
          <button
            v-if="showButton"
            class="show-contacts"
            @click="recaptchaCheck"
          >
            {{ $t('common.show_contacts') }}
          </button>
        </div>
      </div>
    </div>
    <MessageButton
      v-if="isNativeDomain"
      :trainer-name="trFullname"
      class="write-btn"
      :trainer-id="id"
      :icon-email="false"
      :extend-title="true"
    />
    <ReCaptcha v-if="showRecapcha" @change="getOpenedContacts" />
  </div>
</template>

<script>
import MessageButton from '@/components/Search/MessageButton'
import LikesBlock from '@/components/Trainer/LikesBlock'
import constants from '@/dependencies/constants'
import SocialLinksComponent from '@/components/Common/SocialLinksComponent'
import ReCaptcha from '@/components/Recapcha/ReCaptcha'
import CheckNativeDomainMixin from '@/dependencies/mixins/check-native-domain'

export default {
  name: 'TopBlock',
  components: {
    LikesBlock,
    SocialLinksComponent,
    MessageButton,
    ReCaptcha
  },
  mixins: [CheckNativeDomainMixin],
  props: {
    tr: {
      type: Object,
      default: () => {}
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    phones: constants.PHONE.UA,
    contacts: {
      emails: [],
      phones: [],
      site: ''
    },
    showRecapcha: false,
    showButton: true
  }),
  computed: {
    trFullname() {
      return `${this.tr.first_name} ${this.tr.last_name}`
    }
  },
  mounted() {
    this.setHiddenContacts()
  },
  methods: {
    setHiddenContacts() {
      const { emails, phones, site } = this.tr
      this.contacts.emails = emails
      this.contacts.phones = phones
      this.contacts.site = site
    },
    async getOpenedContacts(response) {
      if (response) this.showRecapcha = false

      try {
        const {
          data: { data: contactsOpened }
        } = await this.$api.PublicApi.getOpenContacts(this.id, response)

        this.contacts = contactsOpened
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      }
    },
    recaptchaCheck() {
      this.showButton = false
      this.showRecapcha = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.top-block {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .accent-button {
    min-height: auto;
  }
}

.write-btn {
  width: 100%;
  background-color: $accent;
  height: 41px;
  border-radius: 3px;
  color: #fff;
  font-size: 15px;
  margin-top: 10px;

  &.desktop {
    display: none;
  }
}

.left {
  width: 40%;
}

.avatar {
  border-radius: 3px;
}

.right {
  width: 57%;
  display: flex;
  flex-direction: column;

  .likes-block {
    display: none;
  }

  .name {
    line-height: 1.2;
    margin-bottom: 10px;

    p {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .tr-id {
    margin-bottom: 10px;
    font-size: 13px;
    color: #838383;
  }

  .phones,
  .contacts {
    span,
    a {
      color: #000000;
      display: block;
      font-size: 13px;
      line-height: 1.2;

      i {
        display: none;
      }
    }
  }

  .social-links {
    order: 4;
    margin: 10px 0;
  }

  .bottom-block {
    .write-btn {
      display: none;
    }

    .show-contacts {
      font-size: 16px;
      text-decoration: underline;
      color: #65abb1;
      display: contents;
    }
  }
}

@media (min-width: 768px) {
  .top-block {
    padding: 0;
  }

  .write-btn {
    display: none;
  }

  .left {
    display: none;
  }

  .right {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .likes-block {
      display: flex;
      margin-bottom: 5px;
    }

    .social-links {
      order: unset;
      margin: 0;
      width: 20%;
      height: 40px;
      justify-content: flex-end;
    }

    .name {
      line-height: 1;
      width: 70%;

      p {
        display: inline-block;
        font-size: 38px;
        font-weight: 400;
        color: #474747;

        &:first-child {
          margin-right: 5px;
        }
      }
    }

    .tr-id {
      font-size: 16px;
      width: 100%;
      margin-bottom: 10px;
    }

    .phones,
    .contacts {
      width: 60%;
      padding: 15px;
      background-color: $gray-lighter;
      border: 1px solid #f0f0f0;
      border-radius: 3px;
      line-height: 1.4;
      display: flex;
      flex-wrap: wrap;

      span,
      a {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #474747;

        &:first-child {
          margin-right: 20px;
        }

        i {
          font-size: 20px;
          color: $primary;
          display: inline-block;
        }
      }
    }

    .contacts {
      width: 75% !important;
    }

    .bottom-block {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .contacts {
        &.hidden {
          justify-content: unset;
          flex-wrap: nowrap;

          .tel,
          .mail-site {
            min-width: 210px;
          }

          span {
            margin-right: 0 !important;
            i {
              margin-right: 5px;
            }
          }

          .mail-site {
            a {
              margin-bottom: 15px;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .write-btn {
        width: 25%;
        display: block;
        margin-top: 0;
      }
    }
  }
}
</style>
